module.exports = __webpack_public_path__ + "1679b58b4ab9066e5cb0cb925bcc00b8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/onboarding-fill-in-and-short-answer.png
// module id = 1115
// module chunks = 0